/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {ChangeDetectorRef} from '../change_detection/change_detection';
import {Injector} from '../di/injector';
import {Type} from '../type';

import {ElementRef} from './element_ref';
import {NgModuleRef} from './ng_module_factory';
import {ViewRef} from './view_ref';
/**
 * Represents an instance of a Component created via a {\@link ComponentFactory}.
 * 
 * `ComponentRef` provides access to the Component Instance as well other objects related to this
 * Component Instance and allows you to destroy the Component Instance via the {\@link #destroy}
 * method.
 * \@stable
 * @abstract
 */
export abstract class ComponentRef<C> {
/**
 * Location of the Host Element of this Component Instance.
 * @abstract
 * @return {?}
 */
location() {}
/**
 * The injector on which the component instance exists.
 * @abstract
 * @return {?}
 */
injector() {}
/**
 * The instance of the Component.
 * @abstract
 * @return {?}
 */
instance() {}
/**
 * The {\@link ViewRef} of the Host View of this Component instance.
 * @abstract
 * @return {?}
 */
hostView() {}
/**
 * The {\@link ChangeDetectorRef} of the Component instance.
 * @abstract
 * @return {?}
 */
changeDetectorRef() {}
/**
 * The component type.
 * @abstract
 * @return {?}
 */
componentType() {}
/**
 * Destroys the component instance and all of the data structures associated with it.
 * @abstract
 * @return {?}
 */
destroy() {}
/**
 * Allows to register a callback that will be called when the component is destroyed.
 * @abstract
 * @param {?} callback
 * @return {?}
 */
onDestroy(callback: Function) {}
}
/**
 * \@stable
 * @abstract
 */
export abstract class ComponentFactory<C> {
/**
 * @abstract
 * @return {?}
 */
selector() {}
/**
 * @abstract
 * @return {?}
 */
componentType() {}
/**
 * selector for all <ng-content> elements in the component.
 * @abstract
 * @return {?}
 */
ngContentSelectors() {}
/**
 * the inputs of the component.
 * @abstract
 * @return {?}
 */
inputs() {}
/**
 * the outputs of the component.
 * @abstract
 * @return {?}
 */
outputs() {}
/**
 * Creates a new component.
 * @abstract
 * @param {?} injector
 * @param {?=} projectableNodes
 * @param {?=} rootSelectorOrNode
 * @param {?=} ngModule
 * @return {?}
 */
create(
      injector: Injector, projectableNodes?: any[][], rootSelectorOrNode?: string|any,
      ngModule?: NgModuleRef<any>) {}
}



// WEBPACK FOOTER //
// ../../../../packages/core/src/linker/component_factory.ts